import { Uf } from './models/app-uf.model';

export class AddressConstants {
	static ufLabels: Uf[] = [
		{ id: 12, capital: 'Rio Branco', label: 'Acre', uf: 'AC' },
		{ id: 27, capital: 'Maceió', label: 'Alagoas', uf: 'AL' },
		{ id: 16, capital: 'Macapá', label: 'Amapá', uf: 'AP' },
		{ id: 13, capital: 'Manaus', label: 'Amazonas', uf: 'AM' },
		{ id: 29, capital: 'Salvador', label: 'Bahia', uf: 'BA' },
		{ id: 23, capital: 'Fortaleza', label: 'Ceará', uf: 'CE' },
		{ id: 32, capital: 'Vitória', label: 'Espírito Santo', uf: 'ES' },
		{ id: 52, capital: 'Goiânia', label: 'Goiás', uf: 'GO' },
		{ id: 21, capital: 'São Luís', label: 'Maranhão', uf: 'MA' },
		{ id: 51, capital: 'Cuiabá', label: 'Mato Grosso', uf: 'MT' },
		{ id: 50, capital: 'Campo Grande', label: 'Mato Grosso do Sul', uf: 'MS' },
		{ id: 31, capital: 'Belo Horizonte', label: 'Minas Gerais', uf: 'MG' },
		{ id: 15, capital: 'Belém', label: 'Pará', uf: 'PA' },
		{ id: 25, capital: 'João Pessoa', label: 'Paraíba', uf: 'PB' },
		{ id: 41, capital: 'Curitiba', label: 'Paraná', uf: 'PR' },
		{ id: 26, capital: 'Recife', label: 'Pernambuco', uf: 'PE' },
		{ id: 22, capital: 'Teresina', label: 'Piauí', uf: 'PI' },
		{ id: 33, capital: 'Rio de Janeiro', label: 'Rio de Janeiro', uf: 'RJ' },
		{ id: 24, capital: 'Natal', label: 'Rio Grande do Norte', uf: 'RN' },
		{ id: 43, capital: 'Porto Alegre', label: 'Rio Grande do Sul', uf: 'RS' },
		{ id: 11, capital: 'Porto Velho', label: 'Rondônia', uf: 'RO' },
		{ id: 14, capital: 'Boa Vista', label: 'Roraima', uf: 'RR' },
		{ id: 42, capital: 'Florianópolis', label: 'Santa Catarina', uf: 'SC' },
		{ id: 35, capital: 'São Paulo', label: 'São Paulo', uf: 'SP' },
		{ id: 28, capital: 'Aracaju', label: 'Sergipe', uf: 'SE' },
		{ id: 17, capital: 'Palmas', label: 'Tocantins', uf: 'TO' },
		{ id: 53, capital: 'Brasília', label: 'Distrito Federal', uf: 'DF' },
	];
}
